import React, { useState, useRef, useEffect } from 'react';
import io from "socket.io-client";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    LabelList,
    ResponsiveContainer
} from 'recharts';

// El numero a votar es el indice + 1: la misma numeracion que anuncia el bot en
// el chat y con la que se cuentan los votos (htttpconfig.js). Pintamos comando y
// opcion en un solo <text> con dos tspan para separarlos con dx (los espacios
// repetidos los colapsa SVG) y darles color distinto.
const EtiquetaOpcion = (props) => {
    const box = props.viewBox || props;
    if (!box || box.height == null) return null;
    return (
        <text
            x={box.x + 30}
            y={box.y + box.height / 2}
            dominantBaseline="central"
            fontFamily="Heroes Legend"
            fontWeight={600}
        >
            <tspan fill="#ffffff" fontSize={11}>{'!bet ' + (props.index + 1)}</tspan>
            <tspan fill="#38d84e" fontSize={13} dx={14}>{props.value}</tspan>
        </text>
    );
};

const ApuestasFront = () => {

    const [data, setData] = React.useState([]);
    const [title, setTitle] = React.useState(false);
    const [show, setShow] = React.useState(false);

    useEffect(() => {
        const socket = io('https://forallia.com');
        socket.on('bet', (arg) => {
            if (arg == 'refresh') {
                refreshVotes();
            } else {
                setShow(true);
                processVotes(arg);
                setTimeout(() => {
                    setShow(false);
                }, 60000)
            }
        });
    }, []);

    const refreshVotes = () => {
        fetch('/api/adminLogin' + '?action=get&type=betAll', {
            method: 'POST',
        })
            .then(response => response.json())
            .then(data => {
                processVotes(data);
            });
    }

    const processVotes = (arg) => {
        setTitle(arg.title);
        if (arg.options && arg.options.length > 0) {
            const opts = (arg.options || []).map((item) => ({
                opcion: item.opcion ?? item,
                votos: item.votos ?? 0
            }));
            setData(opts);
        }
    }

    return (
        <div>
            {show && data.length > 0 ? <div>
                <h1 className='heroes corruptos fullCenter'>{title}</h1>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                        data={data}
                        layout="vertical"
                        margin={{ top: 10, right: 40, left: 20, bottom: 10 }}
                    >
                        <XAxis type="number"
                            tick={{
                                fill: '#38d84e',
                                fontSize: 13,
                                fontWeight: 600,
                                fontFamily: 'Heroes Legend'
                            }} />
                        <YAxis
                            dataKey="opcion"
                            type="category"
                            tick={false}
                            axisLine={false}
                            tickLine={false}
                            width={0}
                        />
                        <Tooltip />
                        <Bar dataKey="votos" fill="#292d35">
                            <LabelList dataKey="votos" position="right" style={{
                                fill: '#ff0000',
                                fontSize: 13,
                                fontWeight: 600,
                                fontFamily: 'Heroes Legend',
                                zIndex: 123
                            }} />
                            <LabelList dataKey="opcion" content={<EtiquetaOpcion />} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div> : ''}
        </div>
    );
};

export default ApuestasFront;